import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  Root: {},
  container: {
    width: '100%',
    minWidth: '320px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 120,
    background: theme.palette.background.default,
    '&:after': {
      content: '>',
      position: 'absolute',
      fontSize: 24,
      cursor: 'pointer',
    },
  },
  cardsContainer: {
    flexWrap: 'wrap',
    maxWidth: '100%',
    overflow: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
}));

export default useStyles;
